/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type FleetMapLinesQueryVariables = Types.Exact<{
  serviceAreaId: Types.Scalars['ID']['input']
}>

export type FleetMapLinesQuery = {
  __typename?: 'Query'
  lines: {
    __typename?: 'LinesResponse'
    lines: Array<{
      __typename?: 'Line'
      id: string
      name: Partial<Record<'de' | 'en' | 'no', string>>
      assignedVehicles: Array<string>
      circular: boolean
      color: { __typename?: 'LineColor'; lightMode: string; darkMode: string }
      route: Array<{
        __typename?: 'Location'
        latitude: number
        longitude: number
      }>
      stops: Array<{
        __typename?: 'LineStop'
        stopId: string
        names: Partial<Record<'de' | 'en' | 'no', string>>
        location: {
          __typename?: 'Location'
          latitude: number
          longitude: number
        }
      }>
    }>
  }
}

export const FleetMapLinesDocument = gql`
    query FleetMapLines($serviceAreaId: ID!) {
  lines(serviceAreaId: $serviceAreaId) {
    lines {
      id
      name
      color {
        lightMode
        darkMode
      }
      assignedVehicles
      circular
      route {
        latitude
        longitude
      }
      stops {
        stopId
        names
        location {
          latitude
          longitude
        }
      }
    }
  }
}
    `

/**
 * __useFleetMapLinesQuery__
 *
 * To run a query within a React component, call `useFleetMapLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetMapLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetMapLinesQuery({
 *   variables: {
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function useFleetMapLinesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FleetMapLinesQuery,
    FleetMapLinesQueryVariables
  > &
    (
      | { variables: FleetMapLinesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FleetMapLinesQuery, FleetMapLinesQueryVariables>(
    FleetMapLinesDocument,
    options,
  )
}
export function useFleetMapLinesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FleetMapLinesQuery,
    FleetMapLinesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FleetMapLinesQuery, FleetMapLinesQueryVariables>(
    FleetMapLinesDocument,
    options,
  )
}
// @ts-ignore
export function useFleetMapLinesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FleetMapLinesQuery,
    FleetMapLinesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FleetMapLinesQuery,
  FleetMapLinesQueryVariables
>
export function useFleetMapLinesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FleetMapLinesQuery,
        FleetMapLinesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FleetMapLinesQuery | undefined,
  FleetMapLinesQueryVariables
>
export function useFleetMapLinesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FleetMapLinesQuery,
        FleetMapLinesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FleetMapLinesQuery,
    FleetMapLinesQueryVariables
  >(FleetMapLinesDocument, options)
}
export type FleetMapLinesQueryHookResult = ReturnType<
  typeof useFleetMapLinesQuery
>
export type FleetMapLinesLazyQueryHookResult = ReturnType<
  typeof useFleetMapLinesLazyQuery
>
export type FleetMapLinesSuspenseQueryHookResult = ReturnType<
  typeof useFleetMapLinesSuspenseQuery
>
export type FleetMapLinesQueryResult = Apollo.QueryResult<
  FleetMapLinesQuery,
  FleetMapLinesQueryVariables
>
